import { SyntheticEvent } from 'react';
import { ZodIssue, ZodSchema } from 'zod';
import { CompleteQuery, EditableQuery } from '../types';

export type ValidationPayload = {
  onValidQuery?: () => void;
  onInvalidQuery?: () => void;
  submitEvent?: SyntheticEvent<HTMLFormElement, SubmitEvent>;
};

export type ValidationSuccessPayload = ValidationPayload & {
  parsedQuery: CompleteQuery;
};

export type ValidationFailurePayload = ValidationPayload & {
  errors: ZodIssue[];
};

export const useOnValidate = ({
  onErrorCb,
  onSuccessCb,
  editableQuery,
  schema,
}: {
  editableQuery: EditableQuery;
  schema: ZodSchema<CompleteQuery>;
  onSuccessCb: (payload: ValidationSuccessPayload) => void;
  onErrorCb: (payload: ValidationFailurePayload) => void;
}) => {
  return (payload: ValidationPayload) => {
    const {
      data: completeQuery,
      success,
      error: { errors = [] } = {},
    } = schema.safeParse(editableQuery);
    if (success && !!completeQuery) {
      onSuccessCb({ parsedQuery: completeQuery, ...payload });
    } else {
      onErrorCb({ errors, ...payload });
    }
  };
};
